module.exports = __webpack_public_path__ + "img/1.0d9cdff4.png";